export const actionTypes = {
  SEND_FEEDBACK: 'SEND_FEEDBACK',
  SEND_FEEDBACK_SUCCESS: 'SEND_FEEDBACK_SUCCESS',
  SEND_FEEDBACK_FAILURE: 'SEND_FEEDBACK_FAILURE',
};
